module.exports = __webpack_public_path__ + "img/1.8e5c8d0d.jpg";